<template><UserAgreementEditorBase agreement-type="Double Degree" /></template>
<script>
import UserAgreementEditorBase from '@/views/user/UserAgreementEditorBase'
export default { name: 'UserDoubleDegreeAgreement', components: { UserAgreementEditorBase } }
</script>
